import React, { Fragment } from 'react';
import { fC } from 'helpers/locale';
import PropTypes from 'prop-types';

const PaymentItem = ({ data }) => (
  <Fragment>
    <div className="payment-order-card">
      {data.items.map((item, key) => (
        <div className="payment-order-card__content" key={key}>
          <div className="payment-order-card__image">
            <img src={item.image} alt={item.name} />
          </div>
          <div className="payment-order-card__details">
            <div className="payment-order-card__order-number">
              {`Order No. ${data.order_number}`}
            </div>
            <div className="payment-order-card__product-name">{item.name}</div>
            <div className="payment-order-card__price-note">
              Item Price:
              {` `}
              <strong>{fC(item.price, false)}</strong>
            </div>
            <div className="payment-order-card__totals">
              <div className="payment-order-card__total-row">
                <span>Order Total</span>
                <strong>{fC(data.order_total, false)}</strong>
              </div>
              {data.outstanding_balance ? (
                <div className="payment-order-card__total-row">
                  <span>Outstanding Balance:</span>
                  <strong>{fC(data.outstanding_balance, false)}</strong>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  </Fragment>
);

PaymentItem.propTypes = {
  order_number: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    }),
  ).isRequired,
  order_total: PropTypes.number.isRequired,
  outstanding_balance: PropTypes.number.isRequired,
};

export default PaymentItem;
